import { type RefObject } from 'react';

export type ComposerPopoverVirtualAnchor = {
  getBoundingClientRect: () => DOMRect;
};

export type WorkspaceAgentComposerPopoverAnchorRef = RefObject<HTMLElement | ComposerPopoverVirtualAnchor>;

/** Radix `sideOffset` for composer-anchored pickers (Reference menu, Actions menu, skill menu). */
export const COMPOSER_PICKER_BOTTOM_SIDE_OFFSET_PX = 8;

/** Fallback caret line height when TipTap returns a zero-height decoration rect. */
const COMPOSER_CARET_ANCHOR_FALLBACK_HEIGHT_PX = 20;

const emptyRect = () => new DOMRect();

/**
 * Positions a popover on the TipTap suggestion caret while keeping the panel as wide as the field.
 */
export const createComposerCaretPopoverAnchor = (
  clientRect: () => DOMRect | null,
  widthRef: RefObject<HTMLElement | null>,
): ComposerPopoverVirtualAnchor => ({
  getBoundingClientRect: () => {
    const caret = clientRect();
    const widthSource = widthRef.current;

    if (!widthSource) {
      return emptyRect();
    }

    const widthRect = widthSource.getBoundingClientRect();

    if (!caret) {
      return widthRect;
    }

    const height = caret.height > 0 ? caret.height : COMPOSER_CARET_ANCHOR_FALLBACK_HEIGHT_PX;

    return new DOMRect(widthRect.left, caret.top, widthRect.width, height);
  },
});
